import React from "react";

export const PRERENDER_PENDING_CLASS = "prerender-pending";

/**
 * Retire le masquage posé par public/boot.js sur le HTML FR pré-rendu pour un
 * visiteur EN/ES. useLayoutEffect : au commit du premier rendu, avant le
 * paint — l'app s'affiche directement dans la bonne langue.
 */
export function RevealOnMount({ children }: { children: React.ReactNode }) {
  React.useLayoutEffect(() => {
    document.documentElement.classList.remove(PRERENDER_PENDING_CLASS);
  }, []);
  return <>{children}</>;
}
